import { useContext } from "react";

import { AccordionItemContext } from "../../AccordionItem";

export function useAccordionItem() {
  const context = useContext(AccordionItemContext);

  if (!context) {
    throw new Error(
      "useAccordionItem should be used within the AccordionItemProvider provider."
    );
  }

  return context;
}
